import posthog from 'posthog-js';

const normal_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição Normal' : 'Baixo';
const alarm_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição de Alarme' : 'Médio';
const critical_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição Crítica' : 'Muito Alto';
const potential_problem = posthog.isFeatureEnabled('is-modec') ? 'Problema Potencial' : 'Alto';

export const i18nRecordsPage = {
  title: 'Registros',
  add_a_comment: 'Adicione um comentário',
  view_records: 'Ver registros',
  event_records: 'Registros do evento',
  attachments: 'Anexos',
  comments: 'Comentários',
  summary: {
    attachments: 'Anexos',
    comments: 'Comentários',
    last_update: 'Última atualização: ',
  },

  // MESSAGES
  category: {
    generic: {
      comment: 'Comentário',
      attached_file: 'Arquivo anexado',
      detached_file: 'Arquivo desanexado',
      updated: 'Atualizado',
    },

    Alarm: {
      useful: 'Classificação: Útil',
      not_useful: 'Classificação: Não útil',
      reclassify_useful: 'Reclassificação: Útil',
      reclassify_not_useful: 'Reclassificação: Não útil',
    },
    Case: {
      status_updated: 'Atualizado',
      severity_updated: 'Atualizado',
      created: 'Criado',
      owner_updated: 'Dono Atualizado',
      action_created: 'Criado',
      action_updated: 'Atualizado',
      action_deleted: 'Deletado',
    },
    ConditionDeviation: {
      action_status_updated: 'Status da Ação Atualizado',
      severity_updated: 'Severidade Atualizada',
      created: 'Criado',
      updated: 'Atualizado',
    },
  },
  category_message: {
    generic: {
      attached_file: '@{{user_name}} anexou {{field}}',
      detached_file: '@{{user_name}} desanexou {{field}}',
      updated: '@{{user_name}} alterou: {{field}}',
    },
    Case: {
      status_updated: '@{{user_name}} estado alterado para "{{field}}"',
      severity_updated: '@{{user_name}} severidade alterado para: {{field}}',
      created: '@{{user_name}} Caso criado com severidade {{field}}',
      owner_updated: '@{{field}} é o novo dono do caso',
      action_created: '@{{user_name}} criou a ação {{field}}',
      action_updated: '@{{user_name}} alterou o {{field}} de "{{name}}"',
      action_deleted: '@{{user_name}} deleted Action {{field}}',
    },
    Alarm: {
      useful: '@{{user_name}} reconheceu este alarme como útil, {{field}}',
      not_useful: '@{{user_name}} reconheceu este alarme como não útil, {{field}}',
      reclassify_useful: '@{{user_name}} reclassificou este alarme como útil, {{field}}',
      reclassify_not_useful: '@{{user_name}} reclassificou este alarme como não útil, {{field}}',
    },

    ConditionDeviation: {
      action_status_updated: '@{{user_name}} alterou Status da Ação para {{field}}',
      severity_updated: '@{{user_name}} alterou a Severidade para {{field}}',
      created:
        '@{{user_name}} criou uma condição de desvio com o seguinte status e severidade, respectivamente: {{field}}',
    },
  },
  values: {
    // classification
    useful: 'Útil',
    not_useful: 'Não útil',

    // action_status
    investigating: 'Investigando',
    action_issued: 'Ação emitida',
    canceled: 'Cancelado',
    under_evaluation: 'Em avaliação',
    completed: 'Concluído',
    normal_condition,
    alarm_condition,
    critical_condition,
    potential_problem,
    not_monitored: 'Não Monitorado',
    not_operated: 'Não Operado',

    // severity
    very_high: 'Muito Alta',
    high: 'Alta',
    medium: 'Média',
    low: 'Baixa',
    Information: 'Baixa',
    Warning: 'Baixa',
    Minor: 'Média',
    Major: 'Alta',
    Critical: 'Muito Alta',
  },
};
